import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { api } from '../lib/api';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

export function SubscriptionPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['subscription'],
    queryFn: () => api.get('/api/subscription/get').then((r) => r.data),
  });

  const balance = data?.queryBalance?.credit_balance ?? 0;

  return (
    <div>
      <h1 className="text-2xl font-bold mb-3">Subscription Details</h1>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mb-4">
        <div className="md:col-span-6">
          {isLoading ? (
            <div className="text-center py-12 text-gray-500">Loading subscription info...</div>
          ) : (
            <Card className="rounded-[20px]">
              <h3 className="card-header text-lg font-semibold px-6 py-4 border-b">
                Your Balance
              </h3>
              <CardContent className="pt-3 px-6">
                <ul className="space-y-0">
                  <li className="flex items-center justify-between py-3 border-b border-gray-100">
                    <span>You have {balance} remaining credits.</span>
                  </li>
                  <li className="py-3">
                    <div className="text-end">
                      <Link to="/subscription/request">
                        <Button>Request Additional balance</Button>
                      </Link>
                    </div>
                  </li>
                </ul>
              </CardContent>
            </Card>
          )}
        </div>
      </div>
    </div>
  );
}